import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';

interface NutritionLabelLineItemProps {
  amount?: string;
  border: number;
  dailyValue?: number;
  indent?: number;
  label: string | ReactNode;
}

const NutritionLabelLineItem: FC<NutritionLabelLineItemProps> = ({ amount, border, dailyValue, indent, label }) => {
  return (
    <div
      className={classNames(
        { [`border-b-${border}`]: border > 1, [`border-b`]: border === 1 },
        `border-black flex justify-between`
      )}
    >
      <p className={classNames({ [`ml-${(indent || 0) * 4}`]: indent }, 'nutrition-label__small-copy my-0 py-1')}>
        {label}
        {` `}
        {amount && `${amount}`}
      </p>
      {dailyValue !== undefined && <p className="font-bold nutrition-label__small-copy my-0 py-1">{dailyValue}%</p>}
    </div>
  );
};

export default NutritionLabelLineItem;
